// PROMPT 148: emojis para el cuadro de escribir y para reaccionar, sin librerias nuevas.
// Los que se usan seguido quedan guardados solo en este navegador.

// Los que se ofrecen primero al reaccionar a un mensaje.
export const REACCIONES_RAPIDAS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

const lista = (texto) => texto.split(/\s+/).filter(Boolean);

export const CATEGORIAS_EMOJI = [
  {
    id: "caras",
    titulo: "Caras",
    icono: "😀",
    emojis: lista(
      "😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😍 🥰 😘 😋 😜 🤪 😎 🤩 🥳 😏 😌 😴 🤔 🤗 😬 🙄 😮 😯 😲 😳 😢 😭 😱 😡",
    ),
  },
  {
    id: "gestos",
    titulo: "Gestos",
    icono: "👍",
    emojis: lista(
      "👍 👎 👏 🙌 🙏 🤝 👋 ✌️ 🤞 👌 🤙 💪 👀 🫶 ✋ 🤚 👊 ✊ 🤟 🫡 👉 👈 👆 👇",
    ),
  },
  {
    id: "simbolos",
    titulo: "Corazones y símbolos",
    icono: "❤️",
    emojis: lista(
      "❤️ 🧡 💛 💚 💙 💜 🖤 🤍 💔 💕 💖 💯 ✅ ❌ ⚠️ ❓ ❗ ⭐ ✨ 🔥 🎉 🎊 🎁 🌟 ➡️ ⬅️ 🔝 🆗",
    ),
  },
  {
    id: "viajes",
    titulo: "Viajes y lugares",
    icono: "✈️",
    emojis: lista(
      "✈️ 🗽 🌆 🏙️ 🌉 🚕 🚇 🚌 🚶 🏨 🏖️ 🌴 ☀️ 🌧️ ❄️ 🗺️ 📍 🧳 🎫 🎟️ 🎭 🎡 🍎 🗓️ ⏰ 🚢 🛳️ 🎶",
    ),
  },
  {
    id: "comida",
    titulo: "Comida y bebida",
    icono: "🍕",
    emojis: lista(
      "🍕 🍔 🌭 🥯 🍩 ☕ 🍺 🍷 🥂 🍰 🍪 🍫 🍌 🍓 🥗 🌮 🍣 🍝 🍟 🥤 🍦 🍿",
    ),
  },
  {
    id: "objetos",
    titulo: "Objetos",
    icono: "📱",
    emojis: lista(
      "📱 💻 📷 📎 📄 📅 💳 💵 🔑 🔔 📞 ✉️ 🎧 🕒 🏷️ ✏️ 🛍️ 🧾 📌 🔒 💡 📸",
    ),
  },
];

const CLAVE_FRECUENTES = "wa_emojis_frecuentes";
const MAX_FRECUENTES = 16;

export function leerFrecuentes() {
  try {
    const crudo = window.localStorage.getItem(CLAVE_FRECUENTES);
    const datos = crudo ? JSON.parse(crudo) : [];
    if (!Array.isArray(datos)) return [];
    return datos.filter((e) => typeof e === "string").slice(0, MAX_FRECUENTES);
  } catch {
    return [];
  }
}

export function anotarFrecuente(emoji) {
  try {
    const otros = leerFrecuentes().filter((e) => e !== emoji);
    window.localStorage.setItem(
      CLAVE_FRECUENTES,
      JSON.stringify([emoji, ...otros].slice(0, MAX_FRECUENTES)),
    );
  } catch {
    /* sin almacenamiento en este navegador: no pasa nada */
  }
}
